/**
 * Common mixins
 * 모든 페이지에 기본으로 적용되는 공통 Mixin 모듈
 *
 * @since 2021-09-28
 * @author wj_tams_dev04
 * 불필요한 항목 삭제요망 21.10.01
 */
export default {
  computed: {
    /**
     * NGIPS 페이지를 출력한 브라우저가 IE인지 확인한다. IE이면 true를 리턴한다.
     */
    isIe () {
      return navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1
    },
    /**
     * 해당 장비가 CC인증 모드인지 확인한다. Default는 0 (일반 모드)
     */
    isCcMode () {
      let ccFlag = 0

      try {
        if (this.$store.state.common.common.uiData) {
          ccFlag = this.$store.state.common.common.uiData.system.cc_flag
        }
      } catch (e) {
        ccFlag = 0
      }

      return ccFlag
    },
    /**
     * 해당 장비가 Gs인증 모드인지 확인한다. Default는 0 (일반 모드)
     */
    isGsMode () {
      let gsFlag = 0

      try {
        if (this.$store.state.common.common.uiData) {
          gsFlag = this.$store.state.common.common.uiData.system.gs_flag
        }
      } catch (e) {
        gsFlag = 0
      }

      return gsFlag
    },
    /**
     * 현재 장비가 Stand-alone 또는 HA Master인 경우 True를 리턴한다.
     */
    isRuleMaster () {
      let rule = false

      try {
        const uiData = this.$store.state.common.common.uiData
        const haMode = uiData.ha.mode.toLowerCase()

        if (uiData && haMode !== 'stand-alone') {
          const haMembers = uiData.ha.mmbr || []

          if (haMembers.length > 0) {
            const uuid = uiData.system.host_uuid
            const haState = haMembers.find(mmbr => mmbr.mmbr_uuid === uuid).state

            rule = haState.toLowerCase() === 'master'
          }
        } else {
          rule = true
        }
      } catch (e) {
        rule = false
      }

      return rule
    },
    /**
     * 현재 페이지가 새 창으로 열렸는지 여부를 리턴한다.
     */
    isNewWindow () {
      let newWindow = false

      if (this.$route) {
        newWindow = this.$route.query.newWindow
      }

      return newWindow
    },
    /**
     * 현재 로그인 한 계정의 레벨을 리턴한다. 기본값은 1.
     */
    getUserLevel () {
      let level = 1

      try {
        if (this.$store.state.common.common.uiData) {
          level = this.$store.state.common.common.uiData.user.level
        }
      } catch (e) {
        level = 1
      }

      return level
    },
    /**
     * 현재 로그인 한 계정의 실제 레벨을 리턴한다. 기본값은 1.
     */
    getUserOrgLevel () {
      let level = 1

      try {
        if (this.$store.state.common.common.uiData) {
          level = this.$store.state.common.common.uiData.user.org_level
        }
      } catch (e) {
        level = 1
      }

      return level
    }
  }
}
